export const sortByProperty = (arr:any[], prop:string, constructorFn?:any) => {
	if(constructorFn){
		arr.sort((a, b) => constructorFn(b[prop]) - constructorFn(a[prop]));
		return;
	}
	arr.sort((a, b) => b[prop] - a[prop]);
}


type PropStringFn<T> = (a:T) => string|undefined;


export const sortByDate = <T>(arr:T[], prop:PropStringFn<T>|string) => {

	const fn:PropStringFn<T> = typeof(prop) === "function" ? prop : (it) => (it as any)[prop] as string 

	arr.sort((a, b) => {
		const da = (new Date(fn(a) || "")).getTime();
		const db = (new Date(fn(b) || "")).getTime();
		return db - da;
	});
};